import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CitizensService, citizenGetFullname, CitizenFullInfo } from '@prodcard/core'
import { Ref, ref, watch } from 'vue'
import VAutocompleteServer from './VAutocompleteServer.vue'
import { createCtx, handleError } from '../helpers'

interface CitizenForSelect {
  fullname: string
  id: string
}

interface Props {
  citizensService: CitizensService
  modelValue?: CitizenFullInfo
  label?: string
  loading?: boolean
  disabled?: boolean
  except?: string[]
}

const count = 15


export default /*#__PURE__*/_defineComponent({
  __name: 'VCitizenFullInfoSelect',
  props: {
    citizensService: {},
    modelValue: {},
    label: { default: 'Гражданин' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    except: {}
  },
  setup(__props: any) {

const props = __props;



const citizens: Ref<CitizenForSelect[]> = ref([])
const fullCitizens: Ref<CitizenFullInfo[]> = ref([])

const select = ref()
const loadDefaultCitizen = ref(false)
const isLoadMoreItems = ref(true)
const from = ref(0)
const total = ref(0)
const updateCitizenList = (paging: { from: number; count: number }, filter?: { search: string }, replace = false) => {
  handleError(async () => {
    const response = await props.citizensService.findAllWithInfo(createCtx(), {
      paging,
      filter,
    })

    const resultList = response.items
      .filter(citizenInfo => props.except?.find(i => i === citizenInfo.citizen.id) === undefined)
      .map(citizenInfo => ({ fullname: citizenGetFullname(citizenInfo.citizen), id: citizenInfo.citizen.id }))
    if (replace) {
      fullCitizens.value = response.items
      citizens.value = resultList
    } else {
      fullCitizens.value.push(...response.items)
      citizens.value.push(...resultList)
    }

    isLoadMoreItems.value = fullCitizens.value.length < response.total
    from.value += paging.count
    if (total.value !== response.total) total.value = response.total
  })
}

const updateSearchValue = (val: string) => {
  from.value = 0
  updateCitizenList({ from: from.value, count: count }, { search: val }, true)
}

const findDefaultCitizenById = (id: string) => {
  handleError(async () => {
    const citizen = await props.citizensService.findById(createCtx(), id)
    if (citizen) {
      select.value = { fullname: citizenGetFullname(citizen), id: citizen.id }
    }
  }, loadDefaultCitizen)
}

watch(
  () => props.modelValue,
  val => {
    if (select.value || !val) return
    findDefaultCitizenById(val.citizen.id)
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VAutocompleteServer, {
    modelValue: select.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (
      _ctx.$emit(
        'update:model-value',
        fullCitizens.value.find(c => c.citizen.id === $event?.id),
      )
    ))
    ],
    items: citizens.value,
    isLoadMoreItems: isLoadMoreItems.value,
    label: _ctx.label,
    "item-title": "fullname",
    loading: loadDefaultCitizen.value || _ctx.loading,
    disabled: loadDefaultCitizen.value || _ctx.disabled,
    "onUpdate:searchValue": updateSearchValue,
    onLoadMore: _cache[2] || (_cache[2] = search => updateCitizenList({ from: from.value, count: count }, { search }))
  }, null, 8, ["modelValue", "items", "isLoadMoreItems", "label", "loading", "disabled"]))
}
}

})